import _ from 'underscore';
import { propertyIs } from '@bingads-webui-campaign-react/form-error';

export const DKIThemeDefaultName = 'Asset_Theme_For_DKI';
const pmaxCollectionConfig = {
  headlines: {
    labelText: _TL_('Short headlines (up to 15)'),
    placeholderText: _TL_('Enter your short headline'),
    fieldName: 'short-headline',
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your short headline'),
    deleteButtonLabel: _TL_('Remove short headline'),
    minCollectionSize: 3,
    maxCollectionSize: 15,
    errorMessage: _TL_('At least three short headlines are required'),
    helpPopupTopic: ' pop_BA_CampaignCreate_AudAds_ShortHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about short headlines'),
    inlineRecommendationsTitle: _TL_('Recommended short headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Shortheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about short headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of short headlines. Please remove one short headline if you\'d like to add this recommended short headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('Headlines') },
  },
  longHeadlines: {
    labelText: _TL_('Long headlines (up to five)'),
    placeholderText: _TL_('Enter your long headline'),
    fieldName: 'long-headline',
    singleAssetValidationPropsField: 'LongHeadline',
    validationPropsField: 'LongHeadlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your long headline'),
    deleteButtonLabel: _TL_('Remove long headline'),
    minCollectionSize: 1,
    maxCollectionSize: 5,
    errorMessage: _TL_('At least one long headline is required'),
    helpPopupTopic: 'pop_BA_CampaignCreate_AudAds_LongHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about long headlines'),
    inlineRecommendationsTitle: _TL_('Recommended long headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Longheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about long headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of long headlines. Please remove one long headline if you\'d like to add this recommended long headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('LongHeadlines') },
  },
  descriptions: {
    labelText: _TL_('Descriptions (up to five)'),
    placeholderText: _TL_('Enter your description'),
    fieldName: 'description',
    singleAssetValidationPropsField: 'Description',
    validationPropsField: 'Descriptions',
    addButtonText: _TL_('Add description'),
    copilotButtonLabel: _TL_('Get recommendations for your description'),
    deleteButtonLabel: _TL_('Remove description'),
    minCollectionSize: 2,
    maxCollectionSize: 5,
    errorMessage: _TL_('At least two descriptions are required'),
    helpPopupTopic: 'pop_BA_PMAX_Description',
    helpPopupAriaLabel: _TL_('Click to learn more about descriptions'),
    inlineRecommendationsTitle: _TL_('Recommended descriptions '),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Descriptions',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about descriptions recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of descriptions. Please remove one description if you\'d like to add this recommended description.'),
    duplicateErrorMessage: _TL_('Duplicate descriptions are not allowed'),
    formErrorProps: { filter: propertyIs('Descriptions') },
  },
};

const unifiedAppAdsConfig = {
  headlines: {
    labelText: _TL_('Short headlines (up to 15)'),
    placeholderText: _TL_('Enter your short headline'),
    fieldName: 'short-headline',
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your short headline'),
    deleteButtonLabel: _TL_('Remove short headline'),
    minCollectionSize: 2,
    maxCollectionSize: 15,
    errorMessage: _TL_('At least two short headlines are required'),
    helpPopupTopic: ' pop_BA_CampaignCreate_AudAds_ShortHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about short headlines'),
    inlineRecommendationsTitle: _TL_('Recommended short headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Apps_Headlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about short headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of short headlines. Please remove one short headline if you\'d like to add this recommended short headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('Headlines') },
  },
  descriptions: {
    labelText: _TL_('Descriptions (up to five)'),
    placeholderText: _TL_('Enter your description'),
    fieldName: 'description',
    singleAssetValidationPropsField: 'Description',
    validationPropsField: 'Descriptions',
    addButtonText: _TL_('Add description'),
    copilotButtonLabel: _TL_('Get recommendations for your description'),
    deleteButtonLabel: _TL_('Remove description'),
    minCollectionSize: 1,
    maxCollectionSize: 5,
    errorMessage: _TL_('At least two descriptions are required'),
    helpPopupTopic: 'pop_BA_PMAX_Description',
    helpPopupAriaLabel: _TL_('Click to learn more about descriptions'),
    inlineRecommendationsTitle: _TL_('Recommended descriptions '),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Apps_Descriptions',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about descriptions recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of descriptions. Please remove one description if you\'d like to add this recommended description.'),
    duplicateErrorMessage: _TL_('Duplicate descriptions are not allowed'),
    formErrorProps: { filter: propertyIs('Descriptions') },
  },
};

const windowsStoreAdsConfig = {
  headlines: {
    labelText: _TL_('Short headlines (up to 1)'),
    placeholderText: _TL_('Enter your short headline'),
    fieldName: 'short-headline',
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your short headline'),
    deleteButtonLabel: _TL_('Remove short headline'),
    minCollectionSize: 1,
    maxCollectionSize: 1,
    errorMessage: _TL_('At least two short headlines are required'),
    helpPopupTopic: ' pop_BA_CampaignCreate_AudAds_ShortHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about short headlines'),
    inlineRecommendationsTitle: _TL_('Recommended short headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Shortheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about short headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of short headlines. Please remove one short headline if you\'d like to add this recommended short headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('Headlines') },
  },
};

export const pmaxLiteCollectionConfig = {
  headlines: {
    fieldName: 'short-headline',
    validationPropsField: 'Headlines',
    singleAssetValidationPropsField: 'Headline',
    maxCollectionSize: 15,
    minCollectionSize: 3,
    labelText: _TL_('Short headlines'),
    placeholderText: _TL_('Enter your headline'),
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your short headline'),
    deleteButtonLabel: _TL_('Remove short headline'),
    errorMessage: _TL_('At least 3 short headlines are required'),
    helpPopupTopic: ' pop_BA_CampaignCreate_AudAds_ShortHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about short headlines'),
    inlineRecommendationsTitle: _TL_('Recommended short headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Shortheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about short headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of short headlines. Please remove one short headline if you\'d like to add this recommended short headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('Headlines') },
  },
  longHeadlines: {
    fieldName: 'long-headline',
    validationPropsField: 'LongHeadlines',
    singleAssetValidationPropsField: 'LongHeadline',
    maxCollectionSize: 5,
    minCollectionSize: 1,
    labelText: _TL_('Long headlines'),
    placeholderText: _TL_('Enter your long headline'),
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your long headline'),
    deleteButtonLabel: _TL_('Remove long headline'),
    errorMessage: _TL_('At least 1 long headline is required'),
    helpPopupTopic: 'pop_BA_CampaignCreate_AudAds_LongHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about long headlines'),
    inlineRecommendationsTitle: _TL_('Recommended long headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Longheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about long headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of long headlines. Please remove one long headline if you\'d like to add this recommended long headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('LongHeadlines') },
  },
  descriptions: {
    fieldName: 'description',
    validationPropsField: 'Descriptions',
    singleAssetValidationPropsField: 'Description',
    maxCollectionSize: 5,
    minCollectionSize: 2,
    labelText: _TL_('Descriptions'),
    placeholderText: _TL_('Enter your description'),
    addButtonText: _TL_('Add description'),
    copilotButtonLabel: _TL_('Get recommendations for your description'),
    deleteButtonLabel: _TL_('Remove description'),
    errorMessage: _TL_('At least 2 descriptions are required'),
    helpPopupTopic: 'pop_BA_PMAX_Description',
    helpPopupAriaLabel: _TL_('Click to learn more about descriptions'),
    inlineRecommendationsTitle: _TL_('Recommended descriptions '),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Descriptions',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about descriptions recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of descriptions. Please remove one description if you\'d like to add this recommended description.'),
    duplicateErrorMessage: _TL_('Duplicate descriptions are not allowed'),
    formErrorProps: { filter: propertyIs('Descriptions') },
  },
};

export const displayPlusCollectionConfig = {
  headlines: {
    labelText: _TL_('Short headlines (up to 15)'),
    placeholderText: _TL_('Enter your short headline'),
    fieldName: 'short-headline',
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your short headline'),
    deleteButtonLabel: _TL_('Remove short headline'),
    minCollectionSize: 1,
    maxCollectionSize: 15,
    errorMessage: _TL_('At least one short headline are required'),
    helpPopupTopic: ' pop_BA_CampaignCreate_AudAds_ShortHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about short headlines'),
    inlineRecommendationsTitle: _TL_('Recommended short headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Shortheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about short headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of short headlines. Please remove one short headline if you\'d like to add this recommended short headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('Headlines') },
  },
  longHeadlines: {
    labelText: _TL_('Long headlines (up to five)'),
    placeholderText: _TL_('Enter your long headline'),
    fieldName: 'long-headline',
    singleAssetValidationPropsField: 'LongHeadline',
    validationPropsField: 'LongHeadlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your long headline'),
    deleteButtonLabel: _TL_('Remove long headline'),
    minCollectionSize: 1,
    maxCollectionSize: 5,
    errorMessage: _TL_('At least one long headline is required'),
    helpPopupTopic: 'pop_BA_CampaignCreate_AudAds_LongHeadline',
    helpPopupAriaLabel: _TL_('Click to learn more about long headlines'),
    inlineRecommendationsTitle: _TL_('Recommended long headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Longheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about long headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of long headlines. Please remove one long headline if you\'d like to add this recommended long headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('LongHeadlines') },
  },
  descriptions: {
    labelText: _TL_('Descriptions (up to five)'),
    placeholderText: _TL_('Enter a description'),
    fieldName: 'description',
    singleAssetValidationPropsField: 'Description',
    validationPropsField: 'Descriptions',
    addButtonText: _TL_('Add description'),
    minCollectionSize: 1,
    maxCollectionSize: 5,
    errorMessage: _TL_('At least one description is required'),
    helpPopupTopic: 'pop_BA_Onboarding_Descriptions',
    helpPopupAriaLabel: _TL_('Click to learn more about descriptions'),
    inlineRecommendationsTitle: _TL_('Recommended descriptions '),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Descriptions',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about descriptions recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You’ve reached the maximum number of descriptions. Please remove one description if you’d like to add this recommended description.'),
    duplicateErrorMessage: _TL_('Duplicate descriptions are not allowed'),
    formErrorProps: { filter: propertyIs('Descriptions') },
  },
};

export const searchMMACollectionConfig = {
  ...pmaxLiteCollectionConfig,
  longHeadlines: {
    ...pmaxLiteCollectionConfig.longHeadlines,
    addButtonText: _TL_('Add long headline'),
    formErrorProps: { filter: propertyIs('ResponsiveAdLongHeadlines') },
  },
  headlines: {
    ...pmaxLiteCollectionConfig.headlines,
    minCollectionSize: 1,
    maxCollectionSize: 15,
    errorMessage: _TL_('At least 1 short headline is required'),
    formErrorProps: { filter: propertyIs('ResponsiveAdHeadlines') },
    enableDKI: true,
    DKIThemeName: _TL_('Headline with dynamic keyword'),
  },
  descriptions: {
    ...pmaxLiteCollectionConfig.descriptions,
    labelText: _TL_('Ad text'),
    minCollectionSize: 1,
    errorMessage: _TL_('At least 1 description is required'),
    formErrorProps: { filter: propertyIs('ResponsiveAdDescriptions') },
  },
};

export const linkedinAdCollectionConfig = {
  headlines: {
    labelText: _TL_('Headline'),
    placeholderText: _TL_('Enter your headline'),
    fieldName: 'headline',
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your headline'),
    deleteButtonLabel: _TL_('Remove headline'),
    minCollectionSize: 1,
    maxCollectionSize: 1,
    errorMessage: _TL_('At least one headline are required'),
    helpPopupTopic: 'pop_BA_LinkedIn_Headline',
    helpPopupAriaLabel: _TL_('Click to learn more about short headlines'),
    inlineRecommendationsTitle: _TL_('Recommended headlines'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_LinkedIn_Headline',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You\'ve reached the maximum number of headlines. Please remove one headline if you\'d like to add this recommended headline.'),
    duplicateErrorMessage: _TL_('Duplicate headlines are not allowed'),
    formErrorProps: { filter: propertyIs('Headline') },
    hideAddButtonWhenLimitReached: true,
    hideAddAllSuggestionsButton: true,
    showAssetLabelledBy: true,
    replaceMode: true,
  },
};

export const featureConfigMapping = {
  pmax: pmaxCollectionConfig,
  pmaxLite: pmaxLiteCollectionConfig,
  searchMMA: searchMMACollectionConfig,
  displayPlus: displayPlusCollectionConfig,
  linkedin: linkedinAdCollectionConfig,
  unifiedAppAds: unifiedAppAdsConfig,
  windowsStoreAds: windowsStoreAdsConfig,
};

export const getTextAssetCollectionConfig = (collectionName, i18n, collectionConfig = pmaxCollectionConfig) => {
  const unlocalizedArgs = _.result(collectionConfig, collectionName, undefined);

  if (!unlocalizedArgs) {
    throw new Error(`Invalid text asset collection name: ${collectionName}`);
  }

  const localizedArgs = {
    ...unlocalizedArgs,
    labelText: i18n.getString(unlocalizedArgs.labelText),
    placeholderText: i18n.getString(unlocalizedArgs.placeholderText),
    addButtonText: i18n.getString(unlocalizedArgs.addButtonText),
    errorMessage: i18n.getString(unlocalizedArgs.errorMessage),
    helpPopupAriaLabel: i18n.getString(unlocalizedArgs.helpPopupAriaLabel),
    duplicateErrorMessage: i18n.getString(unlocalizedArgs.duplicateErrorMessage),
  };

  if (unlocalizedArgs.copilotButtonLabel) {
    localizedArgs.copilotButtonLabel = i18n.getString(unlocalizedArgs.copilotButtonLabel);
  }
  if (unlocalizedArgs.deleteButtonLabel) {
    localizedArgs.deleteButtonLabel = i18n.getString(unlocalizedArgs.deleteButtonLabel);
  }

  return localizedArgs;
};
